import { ICasinoVendorViewModel, IVendorDataModel } from "@/fe-core/meta/interfaces/casinoVendors";
import { CasinoVendorsState } from "@/fe-core/meta/types/casinoVendors";
import { RootState } from "@/fe-core/meta/types/root";

export const vendorsSelectorMain = ({
  casinoVendors,
}: RootState): CasinoVendorsState => casinoVendors;

export const vendorDetailsSelector = (
  state: RootState
): ICasinoVendorViewModel | null => {
  const { vendorDetails } = vendorsSelectorMain(state);
  return vendorDetails;
};
export const vendorDetailsPendingSelector = (
  state: RootState
): boolean => {
  const { vendorDetailsPending } = vendorsSelectorMain(state);
  return vendorDetailsPending;
};

export const vendorsSelector = (
  state: RootState
): ICasinoVendorViewModel[] | null => {
  const { vendors } = vendorsSelectorMain(state);

  return vendors;
};
export const subVendorsSelector = (
  state: RootState
): ICasinoVendorViewModel[] | null => {
  const { subVendors } = vendorsSelectorMain(state);

  return subVendors;
};

export const vendorsPendingSelector = (state: RootState): boolean | null => {
  const { pending } = vendorsSelectorMain(state);

  return pending;
};

export const vendorGameDetailsPendingSelector = (state: RootState): boolean | null => {
  const { singleVendorPending } = vendorsSelectorMain(state);

  return singleVendorPending;
};

export const vendorDetailsMoreGamesPendingSelector = (state: RootState): boolean | null => {
  const { vendorDetailsMoreGamesPending } = vendorsSelectorMain(state);

  return vendorDetailsMoreGamesPending;
};

export const singleVendorSelector = (
  state: RootState
): ICasinoVendorViewModel | undefined => {
  const { vendor } = vendorsSelectorMain(state);

  if (!vendor) {
    return undefined;
  }

  return vendor;
};

export const singleSubVendorSelector = (
  state: RootState
): ICasinoVendorViewModel | undefined => {
  const { subVendor } = vendorsSelectorMain(state);

  if (!subVendor) {
    return undefined;
  }

  return subVendor;
};

export const getVendorBySlugSelector =
  (slug: string) =>
    (state: RootState): ICasinoVendorViewModel | undefined => {
      const { vendors } = vendorsSelectorMain(state);

      if (!vendors) {
        return undefined;
      }

      return vendors.find((vendor) => {
        return vendor.slug === slug;
      });
    };

export const getSubVendorBySlugSelector =
  (slug: string) =>
    (state: RootState): ICasinoVendorViewModel | undefined => {
      const { subVendors } = vendorsSelectorMain(state);

      if (!subVendors) {
        return undefined;
      }

      return subVendors.find((vendor) => {
        return vendor.slug === slug;
      });
    };
